module.exports = __webpack_public_path__ + "static/media/greenCheckbox.3b75aca7.svg";